import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=0c5a2f12&"
import script from "./overview.ts?vue&type=script&lang=ts&"
export * from "./overview.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports